import React from 'react';
import { Shield, Sparkles, Target, Heart, CheckCircle, MessageCircle } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { BUSINESS_INFO } from '../utils/constants';

const About = () => {
  const values = [
    { icon: Target, title: 'Excellence', description: 'We strive for perfection in every detail, ensuring your vehicle looks its absolute best.' },
    { icon: Heart, title: 'Customer First', description: 'Your satisfaction is our priority. We go above and beyond to exceed expectations.' },
    { icon: Shield, title: 'Reliability', description: 'Punctual, professional, and consistent service you can depend on every time.' },
    { icon: Sparkles, title: 'Quality', description: 'Premium products and proven techniques for showroom-quality results.' },
  ];

  const whyChooseUs = [
    'Fully mobile service - we come to you',
    'Professional-grade products and equipment',
    'Trained and experienced technicians',
    'Flexible scheduling to fit your lifestyle',
    'Competitive and transparent pricing',
    'Eco-friendly cleaning solutions',
    'Full insurance coverage',
    'Satisfaction guaranteed',
  ];

  return (
    <div>
      <section className="section-blue" style={{ padding: '4rem 0' }}>
        <div className="container text-center">
          <h1>About ARA Mobile Valeting</h1>
          <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto' }}>
            Your trusted partner in professional mobile car care since a year
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="section section-white">
        <div className="container">
          <div className="grid grid-2 gap-xl items-center">
            <div>
              <div className="badge">Our Story</div>
              <h2>Bringing Premium Car Care to Your Doorstep</h2>
              <div className="story-text">
                <p>
                  ARA Mobile Valeting was born from a simple idea: professional car
                  care should be convenient, accessible, and exceptional. We recognized that busy
                  professionals and families needed a better solution than traditional car washes.
                </p>
                <p>
                  What started as a one-person operation has grown into a trusted team of experienced
                  technicians serving Sheffield London and surrounding areas. Our commitment to quality,
                  reliability, and customer satisfaction has earned us hundreds of loyal customers and
                  countless 5-star reviews.
                </p>
                <p>
                  Today, we're proud to be one of the leading mobile valeting services in the region,
                  combining cutting-edge techniques with time-tested methods to deliver results that
                  consistently exceed expectations.
                </p>
              </div>
            </div>

            <div className="grid grid-2 gap-lg">
              <Card hover className="stat-card">
                <div className="stat-number">1+</div>
                <div>Year</div>
                <div className="stat-label">Industry Experience</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">100+</div>
                <div>Vehicles</div>
                <div className="stat-label">Successfully Valeted</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">100+</div>
                <div>Clients</div>
                <div className="stat-label">Satisfied Customers</div>
              </Card>
              <Card hover className="stat-card">
                <div className="stat-number">4.9★</div>
                <div>Rating</div>
                <div className="stat-label">Average Review Score</div>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="section section-cream">
        <div className="container">
          <div className="section-header">
            <div className="badge">Our Values</div>
            <h2>What Drives Us</h2>
            <p>
              Our core values guide everything we do, from how we treat our customers to the quality
              of service we deliver
            </p>
          </div>

          <div className="grid grid-4">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <Card key={index} hover className="value-card">
                  <div className="value-icon">
                    <IconComponent size={40} />
                  </div>
                  <h3 style={{ marginBottom: '0.75rem', fontSize: '1.1rem', fontWeight: '600' }}>
                    {value.title}
                  </h3>
                  <p className="value-description">{value.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section section-cream">
        <div className="container">
          <div className="section-header">
            <div className="badge">Why Choose Us</div>
            <h2>The ARA Difference</h2>
            <p>Here's what sets us apart from other car valeting services</p>
          </div>

          <Card style={{padding: '2rem', maxWidth: '1000px', margin: '0 auto'}}>
            <div className="checklist">
              {whyChooseUs.map((reason, index) => (
                <div key={index} className="checklist-item">
                  <CheckCircle size={24} />
                  <span>{reason}</span>
                </div>
              ))}
            </div>
          </Card>

          {/* CTA */}
          <div className="text-center mt-8">
            <h3 style={{marginBottom: '1rem'}}>Ready to Experience the Difference?</h3>
            <p style={{color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
              Join hundreds of satisfied customers who trust us with their vehicles
            </p>
            <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="whatsapp" size="lg" icon={MessageCircle}>
                Book Your Service Today
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;